// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"e7d07c07","302":"dd8302aa","453":"596171a4"}[chunkId] + ".chunk.js";
};